export class PriceListModel {
 /*  constructor(
    id: string,
    item: string,
    costPrice: number,
    defaultPrice: number,
    clinicPrice: number,
    taxPrice: number) {
  } */
  public id: string;
  public item: string = '';
  public costPrice: number = 0;
  public defaultPrice: number;
  public clinicPrice: number;
  public taxPrice: number;
  public categoryName: string = '';
  public categoryId: string = null;
  public currencyCode: string ='';
}



// WEBPACK FOOTER //
// D:/TMB/sr-git-v1/TMB.UI/src/app/models/centre/price.model.ts